module.exports = __webpack_public_path__ + "img/satenik-swingydibop.2215435.jpg";